import React, {Component} from "react";
import {Control, Field, Select, TextArea} from "bloomer";
import SectionName from "../../../../elements/SectionName";
import FieldDescription from "../../../../elements/FieldDescription";
import WordsLabel from "../../../../elements/WordsLabel";
import InputWarning from "../../../../elements/InputWarning";
import {INVALID_FIELD_STYLE} from "../../../../utils/Constants";
import Spacer from "../../../../elements/Spacer";
import Engines from "../../../../components/model/TextCompletion/Engines";


interface IGeneralState {
    textInput: string;
    textInputEmpty: boolean;
    showLimitWarning: boolean;
    charactersCount: number;
    engines: string[];
    engine: string;
};

class General extends Component<{}, IGeneralState> {
    public INPUT_CHARACTERS_LIMIT: number = 1000;

    public constructor(props: {}) {
        super(props);

        this.state = {
            textInput: "",
            textInputEmpty: false,
            showLimitWarning: false,
            charactersCount: 0,
            engines: [],
            engine: "engine-1"
        };
    }

    public async componentDidMount() {
        const engines = await Engines.list();
        if (engines) {
            this.setState({
                engines
            });
        }
    }

    public handleEngineChange = (e: any) => {
        this.setState({
            engine: e.target.value
        });
    };

    public handleTextInputChange = (e: any) => {
        const value = e.target.value;
        const charactersCount = value.trim().length;
        this.setState({
            textInput: value,
            textInputEmpty: false,
            charactersCount,
            showLimitWarning: charactersCount > this.INPUT_CHARACTERS_LIMIT
        });
    };

    public resetForm = () => {
        this.setState({
            textInput: "",
            textInputEmpty: false,
            showLimitWarning: false,
            charactersCount: 0,
            engine: "engine-1"
        });
    };

    public validateForm = () => {
        if (!this.state.textInput.trim() || this.state.showLimitWarning) {
            if (!this.state.textInput.trim()) {
                this.setState({
                    textInputEmpty: true
                });
            }
            return false;
        }

        return true;
    };

    public getFormData = () => {
        return {
            engine: this.state.engine,
            text: this.state.textInput.trim()
        };
    };

    public render() {
        return <React.Fragment>
            <div>Completes the input text depending on its context or pattern.</div>
            <Spacer/>
            <Field>
                <Control>
                    <SectionName>Engine:</SectionName>
                    <FieldDescription>Different engines have different levels of power and are suitable for different tasks.</FieldDescription>
                    <Select
                        onChange={this.handleEngineChange}
                        value={this.state.engine}
                    >
                        {
                            this.state.engines.map((eng: any) => {
                                return <option key={eng} value={eng}>{eng}</option>;
                            })
                        }
                    </Select>
                </Control>
            </Field>
            <Spacer/>
            <Field>
                <Control>
                    <SectionName>Text:</SectionName>
                    <FieldDescription>Text delimiter is a new line.</FieldDescription>
                    <TextArea
                        rows={7}
                        style={(this.state.textInputEmpty || this.state.showLimitWarning) ? INVALID_FIELD_STYLE : undefined}
                        onChange={this.handleTextInputChange}
                        onPaste={this.handleTextInputChange}
                        value={this.state.textInput}
                        placeholder={"Enter text"}
                    />
                    <div>
                        {
                            this.state.textInputEmpty ? <InputWarning>Please input a text.</InputWarning> : <></>
                        }
                        {
                            this.state.showLimitWarning ?
                                <InputWarning>Input size limit has been exceeded. Please decrease the
                                    size.</InputWarning>
                                : <></>
                        }
                        <WordsLabel>{this.state.charactersCount}</WordsLabel>
                    </div>
                </Control>
            </Field>
            <Spacer/>
        </React.Fragment>;
    }
}

export default General;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/TextCompletion/templates/General.tsx